@app.controller 'ComponentFormController', ($scope, ComponentService, authenticationService, $state, $stateParams) ->
  @showComponentOptions = ['everyone', 'premium', 'non-premium']
  @typeOptions = ['heroSlider', 'hero','matrix','fifty-fifty','feed','header', 'text-block', 'matrix-filter', 'matrix-collapsible', 'divider', 'media', 'banner', 'comments', 'pageNav', 'olapic', 'custom']
  @sizeOptions = ['full','standard','small']
  @themeOptions = ['light','dark','gray','orange']
  @paddedClassOptions = ['','padded padded-large']
  @navOptions = ['ghost']
  # @meta = ComponentService.new()

  @create = =>
    componentParams =
      componentParentType: @parentType
      componentParentId: @parentId
      componentType: @type
      name: @name
      meta: @meta
    ComponentService.create {component: componentParams}, ((component) =>
      if @parentType
        $state.go parentState(@parentType), {id: @parentId}
      else
        $state.go 'main.home'
    ), (error) ->
      console.log 'Error while saving: ', error

  @save = =>
    componentParams =
      componentParentType: @parentType
      componentParentId: @parentId
      componentType: @type
      name: @name
      meta: @meta
      position: @position
    ComponentService.update {id: $stateParams.id, component: componentParams}, ((component) =>
      @goToParent()
    ), (error) ->
      console.log 'Error while saving: ', error

  @cancel = =>
    @goToParent()

  @updateType = (componentType) =>
    newComponentType = ComponentService.new({type:componentType})
    newItem = ComponentService.newItem(componentType)
    @meta = angular.extend {}, newComponentType.meta, @meta
    angular.forEach @meta.items, (item, index) =>
      # If there's already an item from a previous type, keep the values
      if @meta.items[0]
        @meta.items[0] = angular.merge {}, newItem, @meta.items[0]
      else
        @meta.items[0] = newItem

  @clear = =>
    @name = null
    @type = null
    @meta = ComponentService.new().meta

  @delete = =>
    confirmed = confirm 'Are you sure you want to delete this component?'
    if confirmed
      destroySuccess = =>
        @goToParent()
      destroyError = ->
        console.log 'error deleting'
      ComponentService.destroy {id: $stateParams.id}, destroySuccess, destroyError

  @goToParent = =>
    if @parentType
      $state.go parentState(@parentType), {id: @parentId}
    else
      $state.go 'main.home'

  # Saving or cancelling redirect to parent
  parentState = (parentType) ->
    switch parentType
      when 'Page' then 'main.pages'

  @setupExport = =>
    # Set exportUrl
    exportContent =
      type: @type
      meta: @meta

    data = JSON.stringify(exportContent)
    blob = new Blob([ data ], { type : 'application/json' })
    @exportUrl = (window.URL || window.webkitURL).createObjectURL( blob )
    @exportTitle = "component_#{@name}_#{Date.now()}.json"

  @showExperimentUI = false

  $scope.$watch 'component.type', (newValue) =>
    @setupExport()

  $scope.$watch 'component.importFile', (newValue) =>
    if newValue

      fixedstring = decodeURIComponent(escape(newValue))
      newComponentContent = JSON.parse(fixedstring)

      @type = newComponentContent.type
      @meta = newComponentContent.meta

  this

@app.directive 'componentForm', ->
  restrict: 'E'
  scope: {}
  controller: 'ComponentFormController'
  controllerAs: 'component'
  bindToController: {
    parentType: '='
    parentId: '='
    name: '='
    type: '='
    meta: '='
    mode: '='
    position: '='
  }
  templateUrl: "/assets/templates/admin/components/form.html"
